export default "__VITE_ASSET__ad317329__"